// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ez-j";
export var fulfillmentFormRail = "_ez-i";
export var headerTitleRow = "_ez-l";
export var orderDetailsWrapper = "_ez-g";
export var orderLinkTrigger = "_ez-2";
export var paymentInformationGrid = "_ez-q";
export var paymentSummaryColumn = "_ez-r";
export var phoneShipmentPickerButton = "_ez-e";
export var phoneShipmentPickerButtonContent = "_ez-f";
export var phoneShipmentPickerButtonWrapper = "_ez-d";
export var phoneShipmentPickerTrigger = "_ez-c";
export var shipmentContainer = "_ez-k";
export var shipmentDetailsMainPane = "_ez-h";
export var shipmentNavigationCard = "_ez-a";
export var shipmentNavigationEdgeTrigger = "_ez-6";
export var shipmentNavigationRail = "_ez-3";
export var shipmentNavigationRailEnter = "_ez-5";
export var shipmentNavigationRailHeader = "_ez-9";
export var shipmentNavigationRailOverlay = "_ez-4";
export var shipmentNavigationScrim = "_ez-7";
export var shipmentSummaryFact = "_ez-n";
export var shipmentSummaryGrid = "_ez-m";
export var shipmentSummaryMetadataRow = "_ez-o";
export var shipmentSummaryTags = "_ez-p";
export var shipmentWorkspace = "_ez-0";
export var shipmentWorkspaceBodyTablet = "_ez-8";
export var shipmentWorkspaceContent = "_ez-b";
export var shipmentWorkspaceHeader = "_ez-1";